import { Module, Action, VuexModule } from 'vuex-class-modules'
import store from '@/store';
import { MailWizz } from '@/models/mailwizz/mailwizz';
import { mailWizzService } from '@/services/mailwizz-service';
import { SessionStorage } from '@/models/storages/session-storage-factory';

const ACTIVE_MAILWIZZ_INSTANCE_ID = "ACTIVE_MAILWIZZ_INSTANCE_ID"

@Module({ generateMutationSetters: true })
class AppSettingsModule extends VuexModule {
    
    allMailWizzInstances: MailWizz[] = []
    activeMailWizzId: number = 0

    get activeMailWizz() { return this.allMailWizzInstances.find(x => x.id == this.activeMailWizzId) }

    @Action
    async fetchMailWizzInstances() {
        this.allMailWizzInstances = await mailWizzService.getAll()
    }

    @Action
    setActiveMailWizzId(mailWizzId: number) {
        this.activeMailWizzId = mailWizzId
        SessionStorage.set(ACTIVE_MAILWIZZ_INSTANCE_ID, mailWizzId)
    }

    @Action
    setActiveMailWizzFromSession() {
        this.activeMailWizzId = SessionStorage.get(ACTIVE_MAILWIZZ_INSTANCE_ID)
    }
}

export const appSettingsModule = new AppSettingsModule({ store, name: 'appSettings' })
